import { render } from "./Playtime.vue?vue&type=template&id=21df1576"
import script from "./Playtime.vue?vue&type=script&lang=js"
export * from "./Playtime.vue?vue&type=script&lang=js"
script.render = render

export default script